<div class="grid p-fluid">
    <div class="col-12 p-0">
        <div class="flex shift-selection gap-3 align-items-center pl-4">
            <h3 class="col-1 pl-0   ">Shifts : </h3>
            <div class="col sm:col-2">
                <p-dropdown [options]="shifts" [(ngModel)]="selectedShift"
                (onChange)="refreshReport()" optionLabel="name" optionValue="code" placeholder="Shift"></p-dropdown>
            </div>
        </div>
    </div>
    <div class="col-12">
        <p-messages></p-messages>
        <div *ngIf="!loading; else spinner">

            <div *ngFor="let reportData of dreReportData">

                <div class="grid p-fluid shift-selection align-items-center">
                    <div class="col-12 sm:col-4 md:col-2 sm:py-4 sm:pl-4">
                        <h3 class="pl-0">Shift : <span class="font-normal">{{ reportData.commonInfo[0].shift }}</span></h3>
                    </div>
                    <div class="col-12 sm:col-4 md:col-2 sm:py-4">
                        <h3>Date : <span class="font-normal">{{ dreReportDate }}</span></h3>
                    </div>
                    <div class="col-12 sm:col-4 md:col-2 sm:py-4">
                        <h3>Location : <span class="font-normal">{{ dreReportLocation }}</span></h3>
                    </div>
                </div>

                <p-table [value]="reportData.commonInfo">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Report Date</th>
                            <th>Visa/MC Amount</th>
                            <th>Amex Amount</th>
                            <th>Bank Amount</th>
                            <th>Deposit Amount</th>
                            <th>Location #</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data>
                        <tr>
                            <td>{{ data.date }}</td>
                            <td>{{ data.visaDeposit }}</td>
                            <td>{{ data.amexDeposit }}</td>
                            <td>{{ data.bankDeposit }}</td>
                            <td>{{ data.depositAmount }}</td>
                            <td>{{ data.location }}</td>
                        </tr>
                    </ng-template>
                </p-table>

                <p-table [value]="reportData.ticketsIssuedData">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            Tickets Issued
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Lane</th>
                            <th>Starting</th>
                            <th>Ending</th>
                            <th>Qty Issued</th>
                            <th>Comment</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data>
                        <tr>
                            <td>{{ data.Trans1Lane }}</td>
                            <td>{{ data.Trans1Start }}</td>
                            <td>{{ data.Trans1End }}</td>
                            <td>{{ data.Trans1Quantity }}</td>
                            <td>{{ data.Trans1Reason }}</td>
                        </tr>
                    </ng-template>
                </p-table>

                <p-table [value]="reportData.ticketsCollectedData">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            Tickets Collected
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Cashier</th>
                            <th>Tix Collected</th>
                            <th>Amount</th>
                            <th>Comment</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data>
                        <tr>
                            <td>{{ data.Trans2Cashier }}</td>
                            <td>{{ data.Trans2Collected }}</td>
                            <td>{{ data.Trans2Income }}</td>
                            <td>{{ data.Trans2Reason }}</td>
                        </tr>
                    </ng-template>
                </p-table>

                <p-table [value]="reportData.monthlyValidationsData">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            Monthly Validation / Sales
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Rec Type</th>
                            <th>Supply Code</th>
                            <th>Non-Tax</th>
                            <th>Suite #</th>
                            <th>Tenant Name</th>
                            <th>Type</th>
                            <th>Start #</th>
                            <th>End #</th>
                            <th>Qty</th>
                            <th>Income</th>
                            <th>Comment</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data>
                        <tr>
                            <td>{{ data.Grid2Type }} - Key Card</td>
                            <td>{{ data.Grid2SupplyCode }}</td>
                            <td>{{ data.Grid2NonTax }}</td>
                            <td>{{ data.Grid2Suite }}</td>
                            <td>{{ data.Grid2SuiteName }}</td>
                            <td>{{ data.Grid2Tag }}</td>
                            <td>{{ data.Grid2Start }}</td>
                            <td>{{ data.Grid2End }}</td>
                            <td>{{ data.Grid2Qty }}</td>
                            <td>{{ data.Grid2Income }}</td>
                            <td>{{ data.Grid2Reason }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="11">No data found.</td>
                        </tr>
                    </ng-template>
                </p-table>

                <p-table [value]="reportData.otherIncomeData">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            Other Income
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Rec Type</th>
                            <th>Non-Tax</th>
                            <th>Suite #</th>
                            <th>Tenant Name</th>
                            <th>Amount</th>
                            <th>Description</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data>
                        <tr>
                            <td>{{ data.Grid3Type }}</td>
                            <td>{{ data.Grid3NonTax }}</td>
                            <td>{{ data.Grid3Suite }}</td>
                            <td></td><!-- Tenant name -->
                            <td>{{ data.Grid3Amt }}</td>
                            <td>{{ data.Grid3Desc }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="6">No data found.</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        Separate table
                    </ng-template>
                </p-table>
            </div>
        </div>
        <ng-template #spinner>
            <p-progressSpinner></p-progressSpinner>
        </ng-template>
    </div>
</div>

<div class="footer-version">Version: {{version}} {{activeFile}}</div>
